import { mapActions, mapMutations } from 'vuex'
import get from 'lodash/get'
import { getJob, publishJob } from '@/api/jobs/job/job'
import { STATUS_PUBLISHED } from '@/constants/job/jobStatuses'
import { JOB_CHAT } from '@/constants/routes'
import { SnackTypes } from '@/constants/SnackTypes'
import snackMixin from '@/mixins/snackMixin'
import Job from '@/models-ts/job/Job'
import { googleAnalyticsV2 } from '@/servicies-ts/analytics'
import { validateJobPublish } from '@/utils-ts/rules/jobValidation'
import ErrorMatcher from '@/utils/ErrorMatcher'

export default {
  mixins: [snackMixin],
  methods: {
    ...mapActions({
      executeBtnRequest: 'notifications/executeBtnRequest',
    }),
    ...mapMutations({
      setNotificationData: 'notifications/setNotificationData',
    }),
    jobChatLinkPay(note) {
      return {
        name: JOB_CHAT,
        params: { id: note.params.job.id, slug: note.params.job.slug },
        query: { room: note.params.room_id, action: 'pay' },
      }
    },
    jobChatLinkRefund(note) {
      return {
        name: JOB_CHAT,
        params: { id: note.params.job.id, slug: note.params.job.slug },
        query: { room: note.params.room_id, action: 'refund' },
      }
    },
    onPublishJobClick(note) {
      this.executeBtnRequest({
        id: note.id,
        isFirstBtn: false,
        request: async () => {
          try {
            const data = await getJob(note.params.job?.id)
            const job = Job.fromServer(data)
            const validationError = validateJobPublish(job)
            if (!validationError) {
              await publishJob(note.params.job?.id)
              googleAnalyticsV2.send({
                event: 'job-published',
                job_id: note.params.job?.id,
              })
              this.setNotificationData({ id: note.id, path: 'params.job', property: 'status', data: STATUS_PUBLISHED })
              this.openSnackbar({
                type: SnackTypes.SUCCESS,
                text: 'Job was successfully published.',
              })
            } else {
              this.openSnackbar({
                type: SnackTypes.FAILURE,
                text: validationError,
              })
            }
          } catch (e) {
            const defaultErr = 'Error publishing Job. Please try again.'
            const error = ErrorMatcher.isConflict(e) ? get(e, 'response.data.message', defaultErr) : defaultErr
            this.openSnackbar({
              type: SnackTypes.FAILURE,
              text: error,
            })
          }
        },
      })
    },
    onJobPayFreelancerClick(note) {
      const link = this.jobChatLinkPay(note)
      if (link) {
        this.$router.push(link)
      }
    },
    onJobRefundClick(note) {
      this.$router.push(this.jobChatLinkRefund(note))
    },
  },
}
